export type LocaleDefinition = {
  code: string;
  labelKey: string;
  reviewed: boolean;
};

export const LOCALE_DEFINITIONS: LocaleDefinition[] = [
  { code: 'en', labelKey: 'localeEn', reviewed: true },
  { code: 'pt-BR', labelKey: 'localePtBr', reviewed: false },
  { code: 'fr-FR', labelKey: 'localeFrFr', reviewed: false },
];

export const SUPPORTED_LOCALES = LOCALE_DEFINITIONS.map((locale) => locale.code);

export function getSelectableLocales(includeUnreviewed: boolean): LocaleDefinition[] {
  return includeUnreviewed
    ? LOCALE_DEFINITIONS
    : LOCALE_DEFINITIONS.filter((locale) => locale.reviewed);
}
